var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandClockFullLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.35657 14C0.159669 14 0 13.8621 0 13.6921C0 13.5221 0.159669 13.3842 0.35657 13.3842H2.18202C2.21437 11.5553 2.78847 9.89837 3.70047 8.68496C4.26822 7.92952 4.96684 7.34471 5.7487 6.99365C4.96684 6.64259 4.26835 6.05779 3.70047 5.30234C2.79055 4.09185 2.21694 2.43977 2.18215 0.615784H0.35657C0.159669 0.615784 0 0.477899 0 0.307892C0 0.137885 0.159669 0 0.35657 0H14.6433C14.8405 0 15 0.137885 15 0.307892C15 0.477899 14.8405 0.615784 14.6433 0.615784H12.7469C12.7121 2.43977 12.1385 4.09185 11.2286 5.30234C10.6607 6.05779 9.96212 6.64259 9.18037 6.99365C9.96212 7.34484 10.6607 7.92952 11.2286 8.68496C12.1406 9.89837 12.7147 11.5551 12.7471 13.3842H14.6432C14.8403 13.3842 14.9999 13.5221 14.9999 13.6921C14.9999 13.8621 14.8403 14 14.6432 14H0.35657ZM2.96536 1.51203H11.9637C11.9962 1.26166 12.0173 1.00608 12.027 0.74605H2.90225C2.91164 1.00608 2.93289 1.26166 2.96536 1.51203ZM12.0268 13.2414C11.9688 11.6383 11.4601 10.1979 10.6662 9.14191C9.84175 8.0448 8.7093 7.36617 7.46454 7.36617C6.21978 7.36617 5.08732 8.04493 4.26273 9.14191C3.46902 10.1979 2.96011 11.6383 2.90225 13.2414H12.0268Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClockFullLineIcon);
export default __webpack_public_path__ + "static/media/sand-clock-full-line-icon.ba8828c20c117008933084136c59667a.svg";
export { ForwardRef as ReactComponent };